import React from "react";
import { Button } from "@material-ui/core";
import { GitHub, LinkedIn } from "@material-ui/icons";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";

function ContactButtons(props) {
  console.log('##1 props ==> ', props)
  return (
    <div
      style={{ display: "flex", justifyContent: "center", marginBottom: "3em" }}
    >
      <Button
        variant="contained"
        style={{ margin: "1.5rem 0.5rem 0 0" }}
        color="primary"
        startIcon={<LinkedIn />}
        href={props.linkedIn}
        target="_blank"
      >
        LinkedIn
      </Button>
      <Button
        variant="contained"
        style={{
          background: "linear-gradient(to right, #ffff00 0%, #33cc33 100%)",
          margin: "1.5rem 0.5rem 0 0",
        }}
        startIcon={<GitHub />}
        href={props.github}
        target="_blank"
      >
        GitHub
      </Button>
      <Button
        variant="contained"
        style={{ margin: "1.5rem 0 0 0" }}
        color="secondary"
        startIcon={<AssignmentIndIcon />}
        href={props.resume}
        target="_blank"
      >
        Resume
      </Button>
    </div>
  );
}

export default ContactButtons;
